<template>
  <base-select
    style="max-width:140px"
    :value="value"
    :disabled="disabled"
    :ajaxData="getColor"
    :label="label"
    :placeholder="placeholder"
    @change="doChange"
    :error="error"
  >
    <template v-slot:selected="{ item }">
      <div class="d-flex">
        <strong>{{ item.label }}</strong>
        <span
          :style="`background:${item.color}`"
          class="ml-2"
          style="width: 40px; height: 20px; border:1px solid;"
        ></span>
      </div>
    </template>
    <template v-slot:body="{ item }">
      <div class="d-flex">
        <strong>{{ item.label }}</strong>
        <span
          :style="`background:${item.color}`"
          class="ml-2"
          style="width: 40px; height: 20px;  border:1px solid;"
        ></span>
      </div>
    </template>
  </base-select>
</template>
<script>
//
import { colorService } from "@/_services";
export default {
  name: "color",
  props: {
    value: {},
    placeholder: {},
    disabled: {},
    error: {},
    label: {}
  },
  components: {},
  methods: {
    getColor(keyword, cb) {
      colorService.findAll({ search: keyword }).then(res => {
        cb(res.data);
      });
    },
    doChange(item) {
      this.$emit("input", item);
      this.$emit("change", item);
    }
  }
};
</script>
